import { useEffect, useState } from "react";
import { getDiary } from "../api/diaryApi";
import { MoodType } from "../types/appTypes";

interface DiaryProps {
  date: string;
  onSave: (
    id: number | null,
    date: string,
    mood: MoodType,
    text: string
  ) => Promise<void>;
}

/** ✅ 기존 감정 4종만, S3 URL로 교체 */
const moodDefinitions: { key: MoodType; label: string; iconUrl: string }[] = [
  {
    key: "😀",
    label: "기쁨",
    iconUrl:
      "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/icon/smile_icon.svg",
  },
  {
    key: "😐",
    label: "무난",
    iconUrl:
      "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/icon/normal_icon.svg",
  },
  {
    key: "😢",
    label: "슬픔",
    iconUrl:
      "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/icon/sad_icon.svg",
  },
  {
    key: "😠",
    label: "분노",
    iconUrl:
      "https://onion-project-assets.s3.ap-northeast-2.amazonaws.com/assets/icon/angry_icon.svg",
  },
];

export default function Diary({ date, onSave }: DiaryProps) {
  const user_id = localStorage.getItem("user_id") ?? "";

  const [diaryId, setDiaryId] = useState<number | null>(null);
  const [mood, setMood] = useState<MoodType>("😀");
  const [text, setText] = useState("");

  useEffect(() => {
    async function loadDiary() {
      if (!user_id) return;

      try {
        const diary = await getDiary(user_id, date);

        if (diary) {
          setDiaryId(diary.id);
          setMood(diary.mood);
          setText(diary.text);
        } else {
          setDiaryId(null);
          setMood("😀");
          setText("");
        }
      } catch (err) {
        console.error("일기 로드 실패:", err);
        setDiaryId(null);
        setMood("😀");
        setText("");
      }
    }

    loadDiary();
  }, [date, user_id]);

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;

    try {
      await onSave(diaryId, date, mood, text.trim());
      alert("일기가 저장되었습니다."); // ✅ 요청한 최소 팝업
    } catch (err) {
      console.error("일기 저장 실패:", err);
      alert("저장에 실패했습니다.");
    }
  };

  return (
    <section className="diary-container">
      <h3>오늘의 기분</h3>

      <div className="mood-select-container">
        {moodDefinitions.map((m) => (
          <button
            key={m.key}
            type="button"
            onClick={() => setMood(m.key)}
            className={m.key === mood ? "mood-button selected" : "mood-button"}
          >
            <img
              src={m.iconUrl}
              alt={m.label}
              width={28}
              height={28}
            />
            <span>{m.label}</span>
          </button>
        ))}
      </div>

      <form onSubmit={handleSave} className="diary-form">
        <h3>일기</h3>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="오늘 하루를 기록해보세요..."
        />

        <div className="diary-buttons">
          <button type="submit">저장</button>
        </div>
      </form>
    </section>
  );
}
